import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="fLists">
        <ul className="fList">
          <li className="fListItem">Страны</li>
          <li className="fListItem">Регионы</li>
          <li className="fListItem">Города</li>
          <li className="fListItem">Районы</li>
          <li className="fListItem">Аэропорты</li>
          <li className="fListItem">Отели</li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Дома </li>
          <li className="fListItem">Апартаменты </li>
          <li className="fListItem">Курортный отели </li>
          <li className="fListItem">Виллы</li>
          <li className="fListItem">Хостелы</li>
          <li className="fListItem">Гостевые дома</li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Уникальное жилье</li>
          <li className="fListItem">Все направления</li>
          <li className="fListItem">Авиабилеты: все направления</li>
          <li className="fListItem">Отзывы</li>
          <li className="fListItem">Стаатьи</li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Car rental </li>
          <li className="fListItem">Flight Finder</li>
          <li className="fListItem">Restaurant reservations </li>
          <li className="fListItem">Travel Agents </li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Curtomer Service</li>
          <li className="fListItem">Partner Help</li>
          <li className="fListItem">Careers</li>
          <li className="fListItem">Sustainability</li>
          <li className="fListItem">Press center</li>
          <li className="fListItem">Safety Resource Center</li>
          <li className="fListItem">Investor relations</li>
          <li className="fListItem">Terms & conditions</li>
        </ul>
      </div>
      <div className="fText">Copyright © 2022 Mirovonzoda.</div>
    </div>
  );
};

export default Footer;
